/* Seamless infinite marquee.
   Renders two identical tracks and slides by -50% so the loop is seamless. */
export default function Marquee({
  items,
  reverse = false,
  duration = 32,
  className = "",
  separator = "✦",
}) {
  return (
    <div className={`relative overflow-hidden ${className}`}>
      <div
        className="marquee-track"
        style={{
          animation: `${reverse ? "marquee-reverse" : "marquee"} ${duration}s linear infinite`,
        }}
      >
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
            {items.map((item, i) => (
              <span key={i} className="flex items-center shrink-0">
                <span className="px-6">{item}</span>
                <span className="text-acid/70 text-sm">{separator}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
